import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

const KEY = "availity_disclaimer_v1";
const PRIVATE = ["/admin", "/dashboard", "/assessment", "/reset-password", "/certificate/"];

export const DisclaimerSummary = () => (
  <div className="disclaimer-summary" data-testid="disclaimer-summary">
    <p><b>AVAILITY is an independent online certification platform.</b></p>
    <p><b>It is not affiliated with, endorsed by or a substitute for any government body, university, professional licensing board or official certifying organisation.</b></p>
  </div>
);

export const DisclaimerText = () => (
  <div className="disclaimer-text" data-testid="disclaimer-full-text">
    <h3>1. Independence and no affiliation</h3>
    <p>AVAILITY certifications are designed and issued solely by Availity.si. Except where a partnership is expressly stated on this website, AVAILITY is not affiliated with, sponsored by or endorsed by any government authority, university, professional licensing or regulatory board, examination body, payer, or any company with a similar name.</p>
    <h3>2. Nature of the certificate</h3>
    <p>An AVAILITY certificate is AVAILITY's own private credential confirming that the holder passed an AVAILITY assessment. It is not a degree, diploma, statutory licence, government recognition or official certification from any outside certifying organisation, and it does not authorise anyone to practise a regulated profession.</p>
    <h3>3. No guarantee of employment or acceptance</h3>
    <p>We do not guarantee that any employer, institution or organisation will accept, recognise or give weight to an AVAILITY certificate, or that holding one will lead to a job, promotion, salary increase or admission. Decisions about recognition belong entirely to each employer or institution.</p>
    <h3>4. Trademarks</h3>
    <p>Company names, logos, product names and certification names mentioned on this website are the property of their respective owners. Their use is for identification only and does not imply endorsement unless a partnership is expressly stated.</p>
    <h3>5. Question content</h3>
    <p>Assessment questions are based on general, publicly available professional knowledge and common industry practice. They are not official exam material of any outside body, and content may not reflect every jurisdiction, employer policy or the most recent changes in law, codes or standards.</p>
    <h3>6. Payments and refunds</h3>
    <p>Fees are charged as shown on each certification page. Refunds are handled only as described in our <Link to="/refund-policy">Refund &amp; Cancellation Policy</Link>.</p>
    <h3>7. Limitation of liability</h3>
    <p>This website, its assessments and certificates are provided "as is" without warranties of any kind. To the fullest extent permitted by law, Availity.si is not liable for any indirect, incidental or consequential loss arising from use of the website or reliance on any certificate, and our total liability is limited to the fees you paid in the previous 12 months.</p>
    <h3>8. Agreement</h3>
    <p>By continuing to use this website you agree to this disclaimer, our <Link to="/terms">Terms of Service</Link> and our <Link to="/privacy">Privacy Policy</Link>.</p>
  </div>
);

const seen = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

export const DisclaimerGate = () => {
  const { pathname } = useLocation();
  const [agreed, setAgreed] = useState(seen);
  if (agreed || PRIVATE.some((p) => pathname.startsWith(p))) return null;
  const agree = () => { try { localStorage.setItem(KEY, "1"); } catch { /* storage blocked: agree for this visit only */ } setAgreed(true); };
  return (
    <div className="modal-backdrop disclaimer-backdrop">
      <div className="modal disclaimer-modal" role="dialog" aria-modal="true" aria-labelledby="disclaimer-title" data-testid="disclaimer-modal">
        <div className="disclaimer-head"><ShieldAlert size={22} /><h2 id="disclaimer-title">Disclaimer</h2></div>
        <DisclaimerSummary />
        <div className="disclaimer-scroll"><DisclaimerText /></div>
        <div className="disclaimer-actions">
          <Link to="/terms" data-testid="disclaimer-terms-link" onClick={agree}>Read full Terms</Link>
          <button className="button disclaimer-agree" data-testid="disclaimer-agree-button" onClick={agree}>I agree and continue</button>
        </div>
      </div>
    </div>
  );
};
